/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-05 14:54:07
 * @LastEditTime: 2021-12-09 14:45:50
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './app.vue'
import Bus from '../../utils/bus'
import Home from './pages/home/index.vue'
import UserBehavior from './pages/userBehavior'
import Play from './pages/userBehavior/play'
import ReportForms from './pages/reportForms'
import HistoryForms from './pages/historyForms'
import AjaxList from './pages/ajax/list'
import AjaxDetail from './pages/ajax/detail'
import Browser from './pages/browser'
import DoJoin from './pages/doJoin'
import PublishForms from './pages/publishForms'
import axios from 'axios'

Vue.use(Bus)
Vue.use(VueRouter)
// Vue.use(VueResource)
Vue.use(ElementUI)

// 用axios替代vue-resources
// 1.该系统所用vue-resources过久，不支持拦截器
// 2.vue官方早已推荐axios
const instance = axios.create()
instance.interceptors.response.use((response) => {
  const res = response.data
  if (res.code === '100004') {
    axios.get('/sso/systemInfo').then(ssoResponse => {
      const ssoData = ssoResponse.data.data
      if (ssoData.ssoHomeURL) {
        window.location.href = `${ssoData.ssoHomeURL}/login?systemId=143&redirect=${encodeURIComponent(window.location.origin)}`
      }
    })
  } else {
    return response
  }
})
Vue.prototype.$http = instance

const router = new VueRouter({
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/report'
    },
    {
      path: '/home',
      component: Home,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/userBehavior',
      component: UserBehavior,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/play/:recordKey',
      component: Play,
      name: 'play',
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/report',
      component: ReportForms,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/ajax',
      component: AjaxList,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/ajax/detail',
      component: AjaxDetail,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/browser',
      component: Browser,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/doJoin',
      component: DoJoin,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/history',
      component: HistoryForms,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/publish',
      component: PublishForms,
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/sdk',
      component: () => import('./pages/sdk/index.vue'),
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/iosSdk',
      component: () => import('./pages/iosSdk/index.vue'),
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/collapseDetail',
      component: () => import('./pages/collapseDetail/index.vue'),
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    },
    {
      path: '/reportDetail',
      component: () => import('./pages/reportDetail/index.vue'),
      meta: {
        // 需要补全链接
        shouldComplementary: true
      }
    }
  ]
})

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
})
